module.exports = __webpack_public_path__ + "static/peggy-a4da21ca8e4bc3872e7be5e97162eed9.jpg";